import {
  ERROR_MESSAGE_INVALID_PASSWORD_CONFIRMATION,
  ERROR_MESSAGE_MIN_8,
  ERROR_MESSAGE_REQUIRED,
} from '@jobcost-monorepo/utils';

import * as z from 'zod';

export const resetPasswordSchema = z
  .object({
    password: z
      .string({ required_error: ERROR_MESSAGE_REQUIRED })
      .min(8, { message: ERROR_MESSAGE_MIN_8 }),
    confirmPassword: z
      .string({ required_error: ERROR_MESSAGE_REQUIRED })
      .min(8, { message: ERROR_MESSAGE_MIN_8 }),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: ERROR_MESSAGE_INVALID_PASSWORD_CONFIRMATION,
    path: ['confirmPassword'],
  });
